import { Box, Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Spinner, Text } from '@chakra-ui/react';
import React from 'react';

interface StoreChangeModalProps {
    isOpen: boolean;
    selectedStoreVal:any;
    onClose(): void;
}

function StoreChangeModal({ isOpen,selectedStoreVal, onClose, }: StoreChangeModalProps) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered={true} closeOnOverlayClick={false}  >
            <ModalOverlay className='confirmation-modal__overlay' />
            <ModalContent className='confirmation-modal'>
                <ModalBody className='confirmation-modal__body' padding="40px 38.5px" >
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                        <Text sx={{ fontSize: '16px', fontWeight: '700' , textAlign: 'center',marginBottom: '1.5rem' }}>Please wait while we switch you to {selectedStoreVal.store_name}</Text>
                        <Spinner
                            className={`preview-loader`}
                            thickness={'4px'}
                            speed="0.65s"
                            emptyColor={'gray.200'}
                            color="#0C1E46"
                            size={'xl'}
                        />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

export default StoreChangeModal
